enum OtherParentDataCheckStatusEnum {
  Unknown = 0,
  Success = 1,
  SameAsApplicantParent = 2,
  OibFailed = 3,
  DataMismatch = 4,
  NoCustody = 5,
}

export default OtherParentDataCheckStatusEnum;
